var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconElectricity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9968 6.23047L16.6814 16.0949L15.5415 17.317L16.9754 18.1587L26.6699 24.0183L16.7232 33.9678V27.8128H14.0254V38.6039H24.8165V35.9061H18.6615L29.8331 24.7373L31.0538 23.5139L29.5781 22.6276L19.7987 16.7262L27.9365 8.08655L25.9968 6.23047Z",
    fill: "#000957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectricity);
export default __webpack_public_path__ + "static/media/icon_electricity.084aac14212d5f9d96e6815422871074.svg";
export { ForwardRef as ReactComponent };